import { render, staticRenderFns } from "./TraxUiChoice.vue?vue&type=template&id=3e0d8c1b"
import script from "./TraxUiChoice.vue?vue&type=script&lang=js"
export * from "./TraxUiChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports